export const CARD_ASPECT_RATIO: { className: string; aspectRatio: string }[] = [
  { className: 'CARD_16x9', aspectRatio: '16x9' },
  { className: 'CARD_2x3', aspectRatio: '2x3' },
  { className: 'CARD_1x1', aspectRatio: '1x1' },
  { className: ' CARD_9x16', aspectRatio: '9x16' },
];
